import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-priority-list-header',
  standalone: true,
  imports: [FormsModule],
  template: `
    <header class="priority-list-header">
      <div>
        <h2>育成優先リスト</h2>
        <p>面入スコアが低い順で、育成フォローの優先度を確認します。</p>
      </div>

      <div class="date-controls">
        <label>
          <span>表示日</span>
          <input
            type="date"
            [ngModel]="snapshotDate"
            [disabled]="disabled"
            (ngModelChange)="snapshotDateChange.emit($event)"
          />
        </label>
        <label
          title="未指定の場合は表示日が1日なら先月1日、それ以外は当月1日を比較元として自動採用します。"
        >
          <span>比較元</span>
          <input
            type="date"
            [ngModel]="comparisonSnapshotDate"
            [disabled]="disabled"
            (ngModelChange)="comparisonSnapshotDateChange.emit($event)"
          />
        </label>
      </div>
    </header>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .priority-list-header {
        display: flex;
        gap: 16px;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 16px;
      }

      h2 {
        margin: 0;
        color: #0f172a;
        font-size: 22px;
        font-weight: 800;
      }

      p {
        margin: 6px 0 0;
        color: #64748b;
        font-size: 13px;
      }

      .date-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        justify-content: flex-end;
      }

      label {
        display: grid;
        gap: 6px;
        color: #475569;
        font-size: 12px;
        font-weight: 700;
      }

      input {
        min-width: 160px;
        height: 38px;
        padding: 0 10px;
        color: #0f172a;
        font: inherit;
        font-size: 13px;
        background: #ffffff;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
      }

      input:focus {
        border-color: #2563eb;
        outline: 2px solid #bfdbfe;
        outline-offset: 1px;
      }

      @media (width < 720px) {
        .priority-list-header {
          display: grid;
        }

        .date-controls {
          justify-content: stretch;
        }
      }
    `,
  ],
})
export class PriorityListHeaderComponent {
  @Input({ required: true }) snapshotDate = ''
  @Input({ required: true }) comparisonSnapshotDate = ''
  @Input() disabled = false

  @Output() snapshotDateChange = new EventEmitter<string>()
  @Output() comparisonSnapshotDateChange = new EventEmitter<string>()
}
